import { render, staticRenderFns } from "./NUS.vue?vue&type=template&id=578fce4a&"
import script from "./NUS.vue?vue&type=script&lang=js&"
export * from "./NUS.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports